import { createClient } from "@supabase/supabase-js";
import { supabaseUrl, supabaseAnonKey } from "./secrets";
import { supabaseDataProvider } from "ra-supabase";

// More descriptive error logging for missing configuration
if (!supabaseUrl || supabaseUrl.includes("YOUR_ACTUAL")) {
  console.error(
    "ERROR: Missing Supabase URL. Replace with your actual Supabase project URL."
  );
}

if (!supabaseAnonKey || supabaseAnonKey.includes("YOUR_ACTUAL")) {
  console.error(
    "ERROR: Missing Supabase Anon Key. Replace with your actual Supabase anon key."
  );
}

// Improved validation and fallback creation
export const isSupabaseConfigured = () => {
  return (
    supabaseUrl &&
    !supabaseUrl.includes("YOUR_ACTUAL") &&
    supabaseAnonKey &&
    !supabaseAnonKey.includes("YOUR_ACTUAL")
  );
};

// Create Supabase client with more informative error handling
let supabase;
try {
  if (!isSupabaseConfigured()) {
    throw new Error(
      "Supabase configuration missing or using placeholder values"
    );
  }

  // Create the Supabase client
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });

  // Test the client
  console.log("Supabase client initialized successfully");

  // Test auth endpoint availability
  supabase.auth.onAuthStateChange((event, session) => {
    console.log("Auth state changed:", event, !!session);
  });
} catch (error) {
  console.error("Failed to initialize Supabase client:", error);
  // Create a dummy client that will show appropriate errors when methods are called
  supabase = {
    auth: {
      resetPasswordForEmail: () => {
        console.error(
          "Using dummy client - Supabase is not properly configured"
        );
        return Promise.resolve({
          error: {
            message:
              "Supabase is not properly configured. Please set your credentials in src/lib/supabase.ts",
          },
          data: null,
        });
      },
      updateUser: () => {
        console.error(
          "Using dummy client - Supabase is not properly configured"
        );
        return Promise.resolve({
          error: {
            message:
              "Supabase is not properly configured. Please set your credentials in src/lib/supabase.ts",
          },
          data: null,
        });
      },
      getSession: () => {
        console.error(
          "Using dummy client - Supabase is not properly configured"
        );
        return Promise.resolve({
          data: { session: null },
          error: {
            message:
              "Supabase is not properly configured. Please set your credentials in src/lib/supabase.ts",
          },
        });
      },
      onAuthStateChange: () => {
        console.error(
          "Using dummy client - Supabase is not properly configured"
        );
        return { data: { subscription: null } };
      },
    },
  };
}

export const dataProvider = supabaseDataProvider({
  instanceUrl: supabaseUrl,
  apiKey: supabaseAnonKey,
});

export { supabase };
